import React, { Component } from 'react';
import { connect } from 'react-redux';
import { slice } from 'lodash';
import {
    triggerPlayerSkillsFilter
} from '../../../actions/FormationActions';
import common from '../../../common';
import config from '../../../config'

class PlayerSkillsFilterMobile extends Component {
    constructor(props) {
        super(props);
        this.playerSkillsArray = config.skillsFilter;
    }

    // componentDidMount() {
    //     this.props.applySkillFilter(skills.map)
    // }

    onSkillsSelect = (skills) => {
        if (this.props.playerFiltersSkills.indexOf(skills.map) > -1) {
            //to be removed
        } else {
            common.customTracking('Select Position filter - ' + skills.skill,common.getPageName());
        }
        this.props.applySkillFilter(skills.map);

    }

    render() {
        let trans = this.props.trans;
        let self = this;
        return <div className="si-filter-types si-filter-pos">
            <span className="si-title">{ trans.position ? trans.position : "position" }</span>
            <div className="sorting-wrap si-flexBox">

                { self.playerSkillsArray.map((skills) => {
                    const clickableClass = common.makeClasses({
                        'si-sort-option': true,
                        'si-selected': self.props.playerFiltersSkills.indexOf(skills.map) > -1
                    });
                    const toggleSkill = { onClick: () => this.onSkillsSelect(skills) };
                    return <div className="si-sort-box" { ...toggleSkill } key={ skills.map }>
                        <div className={ clickableClass }>
                            { trans[skills.key + "_short"] ? trans[skills.key + "_short"] : skills.key }
                            <span className="si-sort-tick si-flexBox"></span>
                        </div>
                        <div className="si-sort-name">  { trans[skills.key] ? trans[skills.key] : skills.key }</div>
                    </div>
                }) }
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        sortByArr: state.formationData.sortByArr,
        isSortByOpenForWeb: state.formationData.isSortByOpenForWeb,
        sortBy: state.formationData.playerFilters.sortBy,
        playerFiltersSkills: state.formationData.playerFilters.skillId
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        applySkillFilter: (skill) => dispatch(triggerPlayerSkillsFilter(skill))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PlayerSkillsFilterMobile);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/playerSkillsFilterMobile.js